import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const ShopList = () => {
  const [shops, setShops] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef();

  // Fetch shops
  const fetchShops = async () => {
    try {
      const res = await axios.get(
        "https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists"
      );
      setShops(Array.isArray(res.data) ? res.data : []);
    } catch {
      setShops([]);
    }
  };

  useEffect(() => {
    fetchShops();
  }, []);

  // Handle delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this Agent?")) return;
    try {
      await axios.delete(
        `https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists/${id}`
      );
      fetchShops();
    } catch {
      alert("Delete failed");
    }
  };

  // Handle edit
  const handleEdit = (shop) => {
    setEditId(shop.id);
    setEditForm({ ...shop });
    setShowModal(true);
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    try {
      await axios.put(
        `https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists/${editId}`,
        editForm
      );
      setEditId(null);
      setShowModal(false);
      fetchShops();
    } catch {
      alert("Update failed");
    }
  };

  const handleEditCancel = () => {
    setEditId(null);
    setEditForm({});
    setShowModal(false);
  };

  // Close modal on outside click
  useEffect(() => {
    if (!showModal) return;
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setShowModal(false);
        setEditId(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showModal]);

  return (
    <div className="container mt-4">
      {/* Stepper-style sub-navbar */}
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{ gap: 0 }}
      >
        <Link
          to="/createshop"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          1. Create Agent
        </Link>
        <Link
          to="/shoplist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          2. Agent List
        </Link>
        <Link
          to="/DownloadShopQr"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          3. Download QR
        </Link>

        <Link
          to="/shopleadslist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          4. Leads List
        </Link>
      </div>
      <h3 className="mb-4"> All Agent List</h3>
      <div className="table-responsive">
        <table
          className="table table-bordered table-striped align-middle"
          style={{ fontSize: "13px" }}
        >
          <thead className="table-light">
            <tr style={{ whiteSpace: "nowrap" }}>
              <th style={{ minWidth: 70 }}>Agent Code</th>
              <th style={{ minWidth: 90 }}>Agent Name</th>
              <th style={{ minWidth: 90 }}>Owner Name</th>
              <th style={{ minWidth: 120 }}>Address</th>
              <th style={{ minWidth: 60 }}>PIN</th>
              <th style={{ minWidth: 80 }}>Contact</th>
              <th style={{ minWidth: 80 }}>SM Name</th>
              <th style={{ minWidth: 110 }}>SM Email</th>
              <th style={{ minWidth: 90 }}>SM Mobile</th>
              <th style={{ minWidth: 90 }}>Created Date</th>
              <th style={{ minWidth: 90 }}>Created Time</th>
              <th style={{ minWidth: 80 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {shops.toReversed().map((shop) => (
              <tr key={shop.id}>
                <td style={{ verticalAlign: "middle" }}>{shop.shopCode}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.shopname}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.ownername}</td>
                <td style={{ verticalAlign: "middle" }}>
                  {shop.shopfulladdress}
                </td>
                <td style={{ verticalAlign: "middle" }}>{shop.shoppin}</td>
                <td style={{ verticalAlign: "middle" }}>
                  {shop.contactnumber}
                </td>
                <td style={{ verticalAlign: "middle" }}>{shop.smname}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.smemail}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.smmobile}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.createdDate}</td>
                <td style={{ verticalAlign: "middle" }}>{shop.createdTime}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <button
                    className="btn btn-primary btn-sm me-2 mb-1"
                    style={{ fontSize: "12px", padding: "2px 8px" }}
                    onClick={() => handleEdit(shop)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm mb-1"
                    style={{ fontSize: "12px", padding: "2px 8px" }}
                    onClick={() => handleDelete(shop.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Modal */}
      {showModal && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            borderRadius: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            style={{ maxWidth: "95vw", width: 500 }}
          >
            <div
              className="modal-content"
              ref={modalRef}
              style={{
                borderTopLeftRadius: 0,
                borderBottomRightRadius: 0,
                boxShadow: "none",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">Edit Agent</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleEditCancel}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Shop Name</label>
                  <input
                    name="shopname"
                    value={editForm.shopname || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Owner Name</label>
                  <input
                    name="ownername"
                    value={editForm.ownername || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Shop Full Address</label>
                  <input
                    name="shopfulladdress"
                    value={editForm.shopfulladdress || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label"> Pincode</label>
                  <input
                    name="shoppin"
                    value={editForm.shoppin || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Contact Number</label>
                  <input
                    name="contactnumber"
                    value={editForm.contactnumber || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">SM Name</label>
                  <input
                    name="smname"
                    value={editForm.smname || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">SM Email</label>
                  <input
                    name="smemail"
                    value={editForm.smemail || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">SM Mobile</label>
                  <input
                    name="smmobile"
                    value={editForm.smmobile || ""}
                    onChange={handleEditChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-success"
                  onClick={handleEditSave}
                  style={{ zIndex: "9999" }}
                >
                  Save
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={handleEditCancel}
                  style={{ zIndex: "9999" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopList;
